
import { mask } from "vue-the-mask";
import Label from "./Label";

export default {
  directives: { mask },
  name: "Input",
  components: {
    Label
  },
  props: {
    id: {
      type: String,
      required: true
    },
    value: {},
    label: {
      type: String
    },
    type: {
      type: String,
      default: () => "text"
    },
    maxlength: {
      type: Number
    },
    minlength: {
      type: Number
    },
    labelBold: {
      type: Boolean,
      default: () => false
    },
    labelProps: {
      type: Object
    },
    placeholder: {
      type: String
    },
    description: {
      type: String
    },
    success: {
      type: Boolean,
      default: () => false
    },
    error: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    onEnter: {
      type: Function,
      default: () => {}
    },
    mask: {
      type: Array
    }
  },
  methods: {
    handleOnEnter() {
      this.onEnter();
    },
    updateValue(value) {
      this.$emit("input", value);
    }
  },
  computed: {
    inputClass() {
      return {
        "input-margin": !this.description,
        success: this.success,
        error: this.error
      };
    },
    descriptionClass() {
      return {
        success: this.success,
        error: this.error
      };
    }
  }
};
